import { render, staticRenderFns } from "./DataNew.vue?vue&type=template&id=2e22c8d8&scoped=true&"
import script from "./DataNew.vue?vue&type=script&lang=js&"
export * from "./DataNew.vue?vue&type=script&lang=js&"
import style0 from "./DataNew.vue?vue&type=style&index=0&id=2e22c8d8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e22c8d8",
  null
  
)

export default component.exports